var _rect, _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.601,
    y: 3.601,
    width: 34.798,
    height: 34.798,
    rx: 7.366,
    ry: 7.366
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 12.291,
    r: 2.707
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21,18.053h0c1.494,0,2.707,1.213,2.707,2.707v11.656h-5.413v-11.656c0-1.494,1.213-2.707,2.707-2.707Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorInformation);
export default __webpack_public_path__ + "static/media/indoor-information.863c53bcd19bfbe7261999bc18559682.svg";
export { ForwardRef as ReactComponent };